import { IsEnum, IsNotEmpty, IsString } from '@pristine-ts/class-validator';
import { ClientQuestionnaireKeynameEnum } from '../../enums/client-questionnaire/client-questionnaire-keyname.enum';

export abstract class ClientQuestionnaireOptions {
  @IsString()
  @IsEnum(ClientQuestionnaireKeynameEnum)
  @IsNotEmpty()
  abstract keyname: ClientQuestionnaireKeynameEnum;
}
